export const LETTERS =
  "a-zA-ZäöüÄÖÜßÿŸéèêëėÉÈÊËĖûùúūÛÙÚŪîïíīìÎÏÍĪÌôòóõœøōÔÒÓÕŒØŌÀÁÂÆÃÅĀàáâæãåāśšŚŠçćčÇĆČñńÑŃ";
export const SPECIAL_CHARS = "!@#~`´,:;“\"'‘><$%{}^.?/|[\\]&§*)(+=._-\\s";
export const PASSWORD_ALLOWED = `${LETTERS}0-9${SPECIAL_CHARS}`;

export const emailRegex = /^[a-zA-Z0-9][a-zA-Z0-9._-]{1,30}@[a-zA-Z0-9._-]+[a-zA-z0-9]+\.[a-zA-Z]{2,6}$/;
export const passwordRegex = new RegExp(
  `^(?=.*[A-Z])(?=.*[0-9])(?=.*[${SPECIAL_CHARS}])[${PASSWORD_ALLOWED}]{8,15}$`,
);
export const specialChar = new RegExp(
  `^(?=.*[${SPECIAL_CHARS}])[${PASSWORD_ALLOWED}]+$`,
);
export const capitalChar = new RegExp(`^(?=.*[A-Z])[${PASSWORD_ALLOWED}]+$`);
export const char = new RegExp(`^(?=.*[a-z])[${PASSWORD_ALLOWED}]+$`);
export const digitChar = new RegExp(`^(?=.*[0-9])[${PASSWORD_ALLOWED}]+$`);
export const telephoneRegex = /^([+]{0,1}[0-9-]{7,15})$/;
export const registerNumberRegex = /^[A-Za-z0-9]{1,30}$/;
export const digitOnly = /^[0-9]{1,30}$/;
export const nameRegex = new RegExp(`^[${LETTERS}_-]{1,30}$`);
export const charactersOnlyRegex = /^[a-zA-Z_]{1,30}$/;
export const stringRegex = new RegExp(
  `^(?=.*[${LETTERS}])[${LETTERS}0-9.,_-\\s]{1,30}$`,
);
export const domainRegex = /^[a-zA-Z0-9._-]{1,30}$/;
export const configurationRegex = /^[a-z0-9]{1,30}$/;
export const slugRegex = /^[A-Z0-9_]{1,30}$/;
export const colorHexRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
export const urlRegex = /^((ftp|http|https):\/\/)?(www\.)?([A-z0-9-_]+)\.([A-z]{2,})/;
export const htmlTagRegex = /(<([^>]+)>)/gi;

// export const specialChar = /^(?=.*[!@#~`´,:;“"'‘><$%{}^.?/|[\]&§*)(+=._-\s])[äöüÄÖÜßÿŸéèêëėÉÈÊËĖûùúūÛÙÚŪîïíīìÎÏÍĪÌôòóõœøōÔÒÓÕŒØŌÀÁÂÆÃÅĀàáâæãåāśšŚŠçćčÇĆČñńÑŃa-zA-Z0-9!@#~`´,:;“"'‘><$%{}^.?/|[\]&§*)(+=._-\s]{1,}$/;
// export const urlRegex = /^(https?:\/\/)(www\.)?([A-Za-z0-9-_]+)\.([A-Za-z]{2,})(\/.*)?$/;
// export const capitalChar = /^(?=.*?[A-Z])[äöüÄÖÜßÿŸéèêëėÉÈÊËĖûùúūÛÙÚŪîïíīìÎÏÍĪÌôòóõœøōÔÒÓÕŒØŌÀÁÂÆÃÅĀàáâæãåāśšŚŠçćčÇĆČñńÑŃa-zA-Z0-9!@#~`´,:;“"'‘><$%{}^.?/|[\]&§*)(+=._-\s]{1,}$/;
// export const char = /^(?=.*?[a-z])[äöüÄÖÜßÿŸéèêëėÉÈÊËĖûùúūÛÙÚŪîïíīìÎÏÍĪÌôòóõœøōÔÒÓÕŒØŌÀÁÂÆÃÅĀàáâæãåāśšŚŠçćčÇĆČñńÑŃa-zA-Z0-9!@#~`´,:;“"'‘><$%{}^.?/|[\]&§*)(+=._-\s]{1,}$/;
// export const digitChar = /^(?=.*?[0-9])[äöüÄÖÜßÿŸéèêëėÉÈÊËĖûùúūÛÙÚŪîïíīìÎÏÍĪÌôòóõœøōÔÒÓÕŒØŌÀÁÂÆÃÅĀàáâæãåāśšŚŠçćčÇĆČñńÑŃa-zA-Z0-9!@#~`´,:;“"'‘><$%{}^.?/|[\]&§*)(+=._-\s]{1,}$/;

// /* ======================================================
//    CHARACTER SETS
// ====================================================== */

// export const LETTERS =
//   "a-zA-ZäöüÄÖÜßÿŸéèêëėÉÈÊËĖûùúūÛÙÚŪîïíīìÎÏÍĪÌôòóõœøōÔÒÓÕŒØŌÀÁÂÆÃÅĀàáâæãåāśšŚŠçćčÇĆČñńÑŃ";

// export const DIGITS = "0-9";

// export const SPECIAL_CHARS =
//   "!@#~`´,:;“\"'‘><$%{}^.?/|[\\]&§*)(+=._-\\s";

// export const ALPHA_NUMERIC = `${LETTERS}${DIGITS}`;
// export const PASSWORD_ALLOWED = `${ALPHA_NUMERIC}${SPECIAL_CHARS}`;

// /* ======================================================
//    EMAIL
//    (Keep simple — RFC emails are complex)
// ====================================================== */

// export const emailRegex =
//   /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// /* ======================================================
//    PASSWORD RULES
// ====================================================== */

// export const passwordRegex = new RegExp(
//   `^(?=.*[A-Z])(?=.*[0-9])(?=.*[${SPECIAL_CHARS}])[${PASSWORD_ALLOWED}]{8,15}$`
// );

// export const specialChar =
//   new RegExp(`(?=.*[${SPECIAL_CHARS}])`);

// export const capitalChar =
//   /(?=.*[A-Z])/;

// export const char =
//   /(?=.*[a-z])/;

// export const digitChar =
//   /(?=.*[0-9])/;

// /* ======================================================
//    GENERAL INPUT VALIDATION
// ====================================================== */

// export const telephoneRegex =
//   /^\+?[0-9]{7,15}$/;

// export const registerNumberRegex =
//   new RegExp(`^[${ALPHA_NUMERIC}]{1,30}$`);

// export const digitOnly =
//   /^[0-9]{1,30}$/;

// export const nameRegex =
//   new RegExp(`^[${LETTERS}_-]{1,30}$`);

// export const charactersOnlyRegex =
//   /^[a-zA-Z_]{1,30}$/;

// export const stringRegex =
//   new RegExp(
//     `^(?=.*[${LETTERS}])[${ALPHA_NUMERIC}.,_\\-\\s]{1,30}$`
//   );

// export const domainRegex =
//   /^[a-zA-Z0-9._-]{1,30}$/;

// export const configurationRegex =
//   /^[a-z0-9]{1,30}$/;

// export const slugRegex =
//   /^[A-Z0-9_]{1,30}$/;

// /* ======================================================
//    COLORS
// ====================================================== */

// export const colorHexRegex =
//   /^#(?:[0-9a-fA-F]{3}){1,2}$/;

// /* ======================================================
//    URL
// ====================================================== */

// export const urlRegex =
//   /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;

// /* ======================================================
//    HTML TAG DETECTION
// ====================================================== */

// export const htmlTagRegex =
//   /(<([^>]+)>)/gi;
